import { useState } from 'react';
import { useToast } from '@/components/ui';
import { EVENTS, type DutyEvent } from './model';
export interface DutyData {
  events: readonly DutyEvent[];
  reminded: ReadonlySet<string>;
  confirm: (id: string) => void;
  remove: (id: string) => void;
  remind: (id: string) => void;
}
export function useDutyData(): DutyData {
  const [events, setEvents] = useState(EVENTS),
    [reminded, setReminded] = useState<Set<string>>(() => new Set());
  const { toast } = useToast();
  const restore = (event: DutyEvent) =>
    setEvents((previous) =>
      previous.some((e) => e.id === event.id)
        ? previous.map((e) => (e.id === event.id ? event : e))
        : [...previous, event],
    );
  return {
    events,
    reminded,
    confirm: (id) => {
      const before = events.find((e) => e.id === id);
      if (!before) return;
      setEvents((previous) =>
        previous.map((e) =>
          e.id === id ? { ...e, tentative: false, awaitingId: undefined, tone: 'info' } : e,
        ),
      );
      toast({
        title: 'Событие подтверждено',
        tone: 'success',
        action: { label: 'Отменить', undo: true, onClick: () => restore(before) },
      });
    },
    remove: (id) => {
      const before = events.find((e) => e.id === id);
      if (!before) return;
      setEvents((previous) => previous.filter((e) => e.id !== id));
      toast({
        title: 'Событие удалено из образца',
        action: { label: 'Отменить', undo: true, onClick: () => restore(before) },
      });
    },
    remind: (id) => {
      if (reminded.has(id)) return;
      setReminded((previous) => new Set([...previous, id]));
      toast({ title: 'Напоминание отправлено', description: 'Пробное действие в образце' });
    },
  };
}
